import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table for bonus report view.
 * @extends JetView
 */
export default class recordTableBonusReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // Column for ID
                { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' }, // Column for Date with localization
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Column for Type with localization
                { id: 'Amount', header: _('Monto'), width: 100, sort: 'int' }, // Column for Amount with localization
                {
                    id: 'Description',
                    header: _('Descripción'), // Column for Description with localization
                    width: 100,
                    sort: 'int',
                },
            ],
            loadahead: 0, // Number of rows to load ahead
            datafetch: devConfig.getDefaultDataFetch(), // Fetching default data configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.load(
                // Loads data into the grid
                devConfig.geturlApi() + // API URL
                    'es/Report/GetClientBonusReportDetail' + // Endpoint for bonus report
                    '?id=' + // Query parameter for user ID
                    idUser,
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Retrieves the clicked item
            this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Calls event with selected item
        });
    }
}

// FILE DOCUMENTED
